import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { TenantService } from '../../../../Services/tenant.service'
import { Tenant } from "../../../../Models/tenant";
import { IAuthProviderTranslation } from '../Models/IAuthProviderTranslation';

@Injectable({
    providedIn: 'root',
})
export class PassportAdminService {
    private headers: {};

    public get currentTenant(): Tenant {
        return this.tenantService.selectedTenant;
    }
    public get passportApiUrl(): string {
        return this.currentTenant.PassportApiUrl;
    }

    constructor(
        private tenantService: TenantService,
        private http: HttpClient
    ) { }

    public getTenantDetailsAsync(): Promise<Object> {
        return this.get(`${this.passportApiUrl}/Tenants/${this.currentTenant.Value}`).toPromise();
    }

    public updateAuthProviderTranslation(providerId: string, data: IAuthProviderTranslation): Observable<{}> {
        return this
            .put(`${this.passportApiUrl}/translations/auth-providers/${providerId}`, data)
    }

    public getAuthProviderTranslations(providerId: string): Observable<IAuthProviderTranslation[]> {
        return this
            .get(`${this.passportApiUrl}/translations/auth-providers/${providerId}`)
    }

    public getAuthProviders(): Observable<any[]> {
        return this
            .get(`${this.passportApiUrl}/AuthProviders/?client_id=${this.currentTenant.Value}`)
    }

    public getApplications(): Observable<any[]> {
        return this
            .get(`${this.passportApiUrl}/Apps/?client_id=${this.currentTenant.Value}`)
    }


    public saveAuthProvider(provider: any): Observable<Object> {
        if (provider.providerId) {
            return this
                .put(`${this.passportApiUrl}/AuthProviders/${provider.providerId}`, provider);
        }
        else {
            return this.post(`${this.passportApiUrl}/AuthProviders/?client_id=${this.currentTenant.Value}`, provider);
        }
    }

    public saveApplication(editingApplication: any): Observable<Object> {
        if (editingApplication.applicationId) {
            return this
                .put(`${this.passportApiUrl}/Apps/${editingApplication.applicationId}?client_id=${this.currentTenant.Value}`, editingApplication);
        }
        else {
            return this.post(`${this.passportApiUrl}/Apps/?client_id=${this.currentTenant.Value}`, editingApplication);
        }
    }

    public deleteApplication(app: any): Observable<Object> {
        return this.delete(`${this.passportApiUrl}/Apps/${app.applicationId}/?client_id=${this.currentTenant.Value}`);
    }

    public createGuestAccount(provider: any): Observable<Object> {
        if (provider.loginType !== 6 || !provider.isEnabled) {
            return;
        }

        return this.tenantService.createGuestUserIfNotExists(this.currentTenant.Value);
    }

    public createAuthProvider(name: string, metaUrl: string): Promise<Object> {
        return this
            .post(`${this.passportApiUrl}/AuthProviders/?name=${name}&metaUrl=${metaUrl}&client_id=${this.currentTenant.Value}`,
                {})
            .toPromise();
    }

    public deleteAuthProvider(provider: any): Observable<Object> {
        return this.delete(`${this.passportApiUrl}/AuthProviders/${provider.providerId}/`);
    }

    private setHeaders(): void {
        this.headers = {
            headers: new HttpHeaders({
                "passport-apikey": this.currentTenant.PassportApiKey
            })
        };
    }

    private get<T>(url: string) {
        this.setHeaders();
        return this.http.get<T>(url, this.headers);
    }

    private put(url: string, data: any) {
        this.setHeaders();
        return this.http.put(url, data, this.headers);
    }

    private delete(url: string) {
        this.setHeaders();
        return this.http.delete(url, this.headers);
    }

    private post(url: string, data: any) {
        this.setHeaders();
        return this.http.post(url, data, this.headers);
    }
}
